import { Typography } from '@euler/app/components/typography';
import {
  useAiChatActions,
  useAiChatMessage,
} from '@euler/app/flows/ai-suite/chat/AiChatActions';
import { ChatCard } from '@euler/app/flows/ai-suite/components/ChatCard';
import {
  PrimaryButton,
  SecondaryButton,
} from '@euler/app/flows/ai-suite/components/PrimaryButton';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingStoryDraft } from '@euler/model/coaching';
import { NotebookPen } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { channelName, openingName } from '../copy';
import { AssumedItems, Bullets } from './CardBits';

/** The story the coach drafted from the trainee's words, to accept or change. */
export const StoryCard = memo(({ story }: { story: CoachingStoryDraft }) => {
  const { rpx } = useResponsiveContext();
  const chat = useAiChatActions();
  const { latest } = useAiChatMessage();
  return (
    <ChatCard
      icon={NotebookPen}
      color={aiColors.green}
      title={story.title}
      subtitle={`${channelName(story.channel)} · ${openingName(
        story.openingSide,
      )}`}
      tinted
    >
      <View style={{ gap: rpx(12), padding: rpx(14) }}>
        <Typography.Text
          size={rpx(13)}
          color={aiColors.foreground}
          lineHeight={rpx(20)}
        >
          {story.situation}
        </Typography.Text>
        <Bullets title="你知道的情况" items={story.traineeKnows} />
        <AssumedItems items={story.assumed} />
        {latest ? (
          <View style={{ gap: rpx(8) }}>
            <PrimaryButton
              title="就练这个"
              disabled={chat.busy}
              onPress={() => chat.send('就练这个')}
            />
            <SecondaryButton title="改一改" onPress={chat.focusComposer} />
          </View>
        ) : null}
      </View>
    </ChatCard>
  );
});
